import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M6 11A5 5 0 106 1a5 5 0 000 10z" stroke="#fff" strokeMiterlimit="10" /><path d="M6 11c1.381 0 2.5-2.239 2.5-5S7.381 1 6 1C4.62 1 3.5 3.239 3.5 6s1.12 5 2.5 5z" stroke="#fff" strokeMiterlimit="10" /><path stroke="#fff" d="M6.083 1v10M1 5.916h10" /></svg>);